var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1583 20.2583L21.85 23.575M21.8417 14.425L16.1583 17.7417M26.5 13.1667C26.5 14.5474 25.3807 15.6667 24 15.6667C22.6193 15.6667 21.5 14.5474 21.5 13.1667C21.5 11.7859 22.6193 10.6667 24 10.6667C25.3807 10.6667 26.5 11.7859 26.5 13.1667ZM16.5 19C16.5 20.3807 15.3807 21.5 14 21.5C12.6193 21.5 11.5 20.3807 11.5 19C11.5 17.6193 12.6193 16.5 14 16.5C15.3807 16.5 16.5 17.6193 16.5 19ZM26.5 24.8333C26.5 26.214 25.3807 27.3333 24 27.3333C22.6193 27.3333 21.5 26.214 21.5 24.8333C21.5 23.4526 22.6193 22.3333 24 22.3333C25.3807 22.3333 26.5 23.4526 26.5 24.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.f6fe8ebc16ab3f8e4a291e1a4175fe0c.svg";
export { ForwardRef as ReactComponent };